import { render, staticRenderFns } from "./hehuaCultureDetail.vue?vue&type=template&id=f84403a8&scoped=true&"
import script from "./hehuaCultureDetail.vue?vue&type=script&lang=js&"
export * from "./hehuaCultureDetail.vue?vue&type=script&lang=js&"
import style0 from "./hehuaCultureDetail.vue?vue&type=style&index=0&id=f84403a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84403a8",
  null
  
)

export default component.exports